import React from 'react';
import { FolderNav as FolderNavComponent } from '@orijinworks/frontend-commons';
import { Box, withStyles } from '@material-ui/core';
import styles from './index.style';
import CheckEvents from '../users/checkEvents';
import { VerifiedUserIcon } from '../../v2/shared/components/MaterialUIIcons';
import { EventNote, LocationOnOutlined, ListAlt, Settings } from '@material-ui/icons';
import { ManageAds } from '../../v2/modules/manage-ads';
import LocationConfigManager from './LocationConfigManager';
import ManagePrograms from '../../v2/modules/manage-programs/manage-programs'
import ManageRolesV2 from '../../v2/modules/manage-role/manage-roles'
import { EntertainmentIcon } from '../icons';
import useUnleashHook from '../../v2/core/unleash/useUnleashHook';
import { withUnleash } from '../../v2/core/unleash';
import { UnleashService } from '../../v2/services';
import { ManageLocations } from '../../v2/modules/manage-locations';

const LocationConfigManagerTab = () => <LocationConfigManager />;

const SuperAdminModule = ({ classes, unleashProps }) => {
  const adsManagementFlagEnabled = unleashProps.isFlagEnabled();
  const { isFlagEnabled: manageProgramFlagEnabled } = useUnleashHook(UnleashService.FLAGS.MANAGE_PROGRAMS);

  const tabs = [
    {
      label: 'Location Management',
      value: '1',
      component: () => <ManageLocations />,
      Icon: LocationOnOutlined,
    },
    {
      label: 'Roles',
      value: '2',
      component: () => <ManageRolesV2 />,
      Icon: VerifiedUserIcon,
    },
    {
      label: 'Check Events',
      value: '3',
      component: () => <CheckEvents />,
      Icon: EventNote,
    },
    {
      label: 'Configuration Manager',
      value: '6',
      component: LocationConfigManagerTab,
      Icon: Settings,
    },
  ];

  if (adsManagementFlagEnabled) {
    tabs.push({
      label: 'Manage Ads',
      value: '4',
      component: () => <ManageAds />,
      Icon: EntertainmentIcon,
    });
  }

  if (manageProgramFlagEnabled()) {
    tabs.push({
      label: 'Manage Programs',
      value: '5',
      component: () => <ManagePrograms />,
      Icon: ListAlt,
    });
  }

  tabs.sort((a, b) => a.value - b.value);

  return (
    <Box className={classes.folderWrapper}>
      <FolderNavComponent defaultActiveTab="1" color="var(--yellow-main)" tabs={tabs} />
    </Box>
  );
};

const MemoizedSuperAdminModule = React.memo(SuperAdminModule, (prevProps, nextProps) => {
  return true;
});
 
export default withUnleash(withStyles(styles)(MemoizedSuperAdminModule), UnleashService.FLAGS.ADS_MANAGEMENT);